import Tool, {
  type IToolActionInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import Shortcut from '../utils/Shortcut';
import type Shape from '../objects/Shape';
import type ShapeImage from '../shapes/ShapeImage';

class ToolCrop extends Tool {
  static toolName = 'Crop image';

  static action({ controller, selection }: IToolActionInput) {
    // Reset the stylus to pointer when starting crop.
    controller.actionResetStylus();
    controller.actionStartCropping(selection as Shape<ShapeImage>);
  }

  // We do not allow cropping rotated images.
  static enabled({ controller, selection }) {
    return (
      super.enabled({ controller, selection }) &&
      selection &&
      (selection.angle || 0) === 0
    );
  }

  static buttonComponent() {
    return simpleToolButton(ToolCrop, 'fa-regular fa-crop-simple');
  }
}

class ToolAbortCrop extends Tool {
  static toolName = 'Abort crop';
  static shortcut = new Shortcut('Esc');

  static action({ controller }: IToolActionInput) {
    controller.actionEndCropping(true);
  }

  static enabled({ controller }: IToolEnabledInput) {
    return controller.isCropping();
  }
}

class ToolCommitCrop extends Tool {
  static toolName = 'Commit crop';
  static shortcut = new Shortcut('Enter');

  static action({ controller }: IToolActionInput) {
    controller.actionEndCropping();
  }

  static enabled({ controller }: IToolEnabledInput) {
    return controller.isCropping();
  }
}

export { ToolCrop, ToolAbortCrop, ToolCommitCrop };
